import { EmailMarketingProvider, TenantCredentialType } from "generated/graphql";
import React from "react";
import { AudienceManager, AudienceManagerConfig } from "../audience/audience-manager";

interface ConstantContactProps {
    match?: {
        path?: string;
        params?: {
            audienceId?: string;
            subtab?: string;
            audienceTab?: string;
        };
    };
}

const constantContactConfig: AudienceManagerConfig = {
    providerName: "Constant Contact",
    credentialType: TenantCredentialType.ConstantContact,
    redirectPath: "/settings/integrations/constant-contact",
    authUri: "/api/auth/constantcontact",
    provider: EmailMarketingProvider.ConstantContact,
};

export const ConstantContact: React.FC<ConstantContactProps> = props => {
    return <AudienceManager config={constantContactConfig} match={props.match} />;
};
